import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the home state domain
 */

const selectHomeDomain = state => state.home || initialState;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Home
 */

const selectHomeData = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.homeData,
  );

const selectHomeList = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.homeList,
  );

const selectHomeLoading = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.loading,
  );

const selectHomeError = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.error,
  );

const selectHomeDeleteSuccessful = () =>
  createSelector(
    selectHomeDomain,
    substate => substate.deleteSuccessful,
  );

export {
  selectHomeDomain,
  selectHomeLoading,
  selectHomeError,
  selectHomeDeleteSuccessful,
  selectHomeData,
  selectHomeList,
};
